module.exports = __webpack_public_path__ + "static/media/bb-banner.4ccc9f0e.webp";